module.exports = __webpack_public_path__ + "img/image-collection-sliding-overlays-chevy.c0aa6c8b.png";